








import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
  name: 'i-download'
})
export default class IDownload extends Vue {
  @Prop({type: String, default: '#2D9CDB'}) protected color!: string
}
